<template>
  <el-dialog :visible.sync="show" title="选择聚能谷桩" :before-close="closeDialog" width="1200px">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="聚能谷桩号">
        <el-input placeholder="请输入聚能谷桩号" v-model="NumberBox" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="getData()">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>
    <el-table border v-loading="loading" :data="tableData" highlight-current-row @current-change="handleTripletChange"
      header-cell-class-name="table-header-cell">
      <el-table-column label="选择" width="55" align="center">
        <template slot-scope="{row}">
          <el-radio v-model="selectedId" :label="row.ID"><span></span></el-radio>
        </template>
      </el-table-column>
      <el-table-column label="聚能谷桩名称" prop="EName" width="100"></el-table-column>
      <el-table-column label="聚能谷桩号" width="220" prop="NumberBox"></el-table-column>
      <el-table-column label="设备枪数量" prop="Count" width="100"></el-table-column>
      <el-table-column label="设备类型" prop="TypeName" width="130"></el-table-column>
      <el-table-column label="站点名称" prop="regionName" show-overflow-tooltip></el-table-column>
      <el-table-column label="当前版本号" prop="EQedition" show-overflow-tooltip></el-table-column>
      <el-table-column label="sim卡号1" prop="simcard1" show-overflow-tooltip></el-table-column>
      <el-table-column label="sim卡号2" prop="simcard2" show-overflow-tooltip></el-table-column>

      <el-table-column label="创建时间" width="160" prop="Createtime"></el-table-column>
      <el-table-column label="最后上报时间" width="160" prop="lasttime"></el-table-column>
      <el-table-column label="预约模式" width="150" prop="IsOrder">
        <template slot-scope="{ row }">
          <el-switch :value="row.IsOrder" active-value="1" inactive-value="0"
            @change="onOrderModelChange(row)"></el-switch>
          <span class="ml-10">{{
            row.IsOrder == 0 ? "平台预约" : "设备预约"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否即插即充" prop="IsPlugandCharge" width="150">
        <template slot-scope="{ row }">
          {{ row.IsPlugandCharge == 1 ? "是" : "否" }}
        </template>
      </el-table-column>
    </el-table>
    <div class="my-pagination">
      <el-pagination background layout="total,prev,pager,next" :total="pageParams.total" :page-size="pageParams.limit"
        :page-sizes="[10, 20, 30, 40, 50]" :current-page="pageParams.page" @size-change="handleSizeChange"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
    <span slot="footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button @click="comfirmDialog" type="primary">确定并关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { GetPageListForAdd } from "@/api/dev_archive";
import pageMixin from '@/mixins/cptMixin.js';
export default {
  mixins: [pageMixin],
  data() {
    return {
      loading: false,
      tableData: [],
      typename: "",
      selectItem: '',
      NumberBox:"",
      pageParams: {
        page: 1,
        limit: 20,
        total: 0
      },
      selectedId: ''
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    siteId: {
      type: [String, Number],
      default: ""
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.typename = this.siteId;
        this.getData();
      } else {
        this.selectItem = '';
        this.selectedId = '';
      }
    }
  },
  methods: {
    comfirmDialog() {
      console.log(this.selectItem)
      if (!this.selectItem) {
        this.$message.error('请先选择数据');
        return;
      }
      // if (this.selectItem.State == 0) {
      //   this.$message.error('此三元组已被禁用，请重新选择');
      //   return;
      // }
      this.$emit('confirm', this.selectItem);
    },
    getData() {
      this.loading = true;
      GetPageListForAdd({
        page: this.pageParams.page,
        limit: this.pageParams.limit,
        Number:this.NumberBox
        // typename:this.typename
      }).then(res => {
        this.tableData = res.data;
        this.pageParams.total = Number(res.total);
      }).finally(() => { this.loading = false; });
    },
    closeDialog() {
      this.$emit('update:show', false);
    },
    handleTripletChange(val) {
      if (val) {
        this.selectedId = val.ID;
        this.selectItem = val;
      }
    }
  }
}
</script>